import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';

var _templateObject = _taggedTemplateLiteral(['\n  border-radius: 18px;\n  padding: 14px;\n  background-color: ', ';\n  position: absolute;\n  background: ', ';\n'], ['\n  border-radius: 18px;\n  padding: 14px;\n  background-color: ', ';\n  position: absolute;\n  background: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  top: 8px;\n  right: 8px;\n  svg {\n    height: auto;\n  }\n'], ['\n  top: 8px;\n  right: 8px;\n  svg {\n    height: auto;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  top: 8px;\n  left: 8px;\n  svg {\n    height: auto;\n  }\n'], ['\n  top: 8px;\n  left: 8px;\n  svg {\n    height: auto;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  && {\n    padding: 6px 10px;\n  }\n'], ['\n  && {\n    padding: 6px 10px;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  && {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    vertical-align: middle;\n    border-radius: 3px;\n    padding: 6px;\n    background-color: ', ';\n  }\n'], ['\n  && {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    vertical-align: middle;\n    border-radius: 3px;\n    padding: 6px;\n    background-color: ', ';\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  && {\n    margin-left: 4px;\n  }\n'], ['\n  && {\n    margin-left: 4px;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  && {\n    margin-right: 4px;\n  }\n'], ['\n  && {\n    margin-right: 4px;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  height: 32px;\n  font-size: 12px;\n  border-radius: 14px;\n  font-weight: 500;\n  width: 144px;\n  margin: 4px;\n  padding: 6px 10px;\n  flex: initial;\n  @media (max-width: 359px) {\n    width: 120px;\n  }\n  &:hover {\n    background-color: ', ';\n    .button-label {\n      color: white;\n    }\n  }\n'], ['\n  height: 32px;\n  font-size: 12px;\n  border-radius: 14px;\n  font-weight: 500;\n  width: 144px;\n  margin: 4px;\n  padding: 6px 10px;\n  flex: initial;\n  @media (max-width: 359px) {\n    width: 120px;\n  }\n  &:hover {\n    background-color: ', ';\n    .button-label {\n      color: white;\n    }\n  }\n']);

import React from 'react';
import styled from 'styled-components';
import { styles } from 'gipsy-misc';
import ReusableButton from './index';
import Icon from '../Icon';

/*
  how it works :
    These are just "ready to use" templates of <Button />, already styled.
    However you can change the style in 2 ways :
      it will inherit any props you pass, you can customize it the same way you would with <Button backgroundColor='red' style={...} />
      you can override it with styled-components (ie: const Button = styled(LargeButtonIcon)`...`)
*/

/* ie : task panel - create button */
var LargeButton = function LargeButton(_ref) {
  var leftIconName = _ref.leftIconName,
      rightIconName = _ref.rightIconName,
      iconBackgroundColor = _ref.iconBackgroundColor,
      iconBackground = _ref.iconBackground,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['leftIconName', 'rightIconName', 'iconBackgroundColor', 'iconBackground', 'children']);

  return React.createElement(
    ReusableButton,
    _extends({
      height: 56,
      leftIcon: leftIconName ? React.createElement(LargeIconLeft, {
        icon: leftIconName,
        size: 40,
        backgroundColor: iconBackgroundColor,
        background: iconBackground,
        fill: 'white'
      }) : undefined,
      rightIcon: rightIconName ? React.createElement(LargeIconRight, {
        icon: rightIconName,
        size: 40,
        backgroundColor: iconBackgroundColor,
        background: iconBackground,
        fill: 'white'
      }) : undefined
    }, rest),
    children
  );
};

export { LargeButton };
var LargeIcon = styled(Icon)(_templateObject, function (props) {
  return props.backgroundColor || styles.colors.primaryDarkColor;
}, function (props) {
  return props.background;
});

var LargeIconRight = styled(LargeIcon)(_templateObject2);

var LargeIconLeft = styled(LargeIcon)(_templateObject3);

/* ie : chromext - create button */
var SmallButtonDefault = function SmallButtonDefault(_ref2) {
  var leftIconName = _ref2.leftIconName,
      rightIconName = _ref2.rightIconName,
      iconBackgroundColor = _ref2.iconBackgroundColor,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ['leftIconName', 'rightIconName', 'iconBackgroundColor', 'children']);

  return React.createElement(
    ReusableButton,
    _extends({
      height: 32,
      width: 'auto',
      fontSize: 12,
      borderRadius: 4,
      leftIcon: leftIconName ? React.createElement(SmallIconLeft, { icon: leftIconName, size: 20, backgroundColor: iconBackgroundColor, fill: 'white' }) : undefined,
      rightIcon: rightIconName ? React.createElement(SmallIconRight, { icon: rightIconName, size: 20, backgroundColor: iconBackgroundColor, fill: 'white' }) : undefined
    }, rest),
    children
  );
};

/*
 ** we need && here because we target SmallButtonDefault instead of Button,
 ** there's an extra step so our style here doesnt have priority
 */
export var SmallButton = styled(SmallButtonDefault)(_templateObject4);

var SmallIcon = styled(Icon)(_templateObject5, function (props) {
  return props.backgroundColor || styles.colors.primaryDarkColor;
});

var SmallIconRight = styled(SmallIcon)(_templateObject6);

var SmallIconLeft = styled(SmallIcon)(_templateObject7);

export var DatePickerButton = styled(ReusableButton)(_templateObject8, styles.colors.darkGrey);
//# sourceMappingURL=Buttons.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ReusableButton/Buttons.js
// module id = 178
// module chunks = 0